import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "management-client_id"
}, " Client ", -1)
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "management-installation_date"
}, "Installation Date", -1)
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "management-contract_expiry"
}, "Contract Expiry", -1)
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "client-contract_value"
}, "Project Value", -1)
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "client-service_contract_value"
}, "Service Contract Value", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_date_picker = _resolveComponent("n-date-picker")!
  const _component_n_input_number = _resolveComponent("n-input-number")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_n_select, {
                  id: "management-client_id",
                  value: _ctx.modelValue.client_id,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValue.client_id) = $event)),
                  disabled: "",
                  options: _ctx.clientOptions,
                  loading: !_ctx.clientOptions,
                  size: "large"
                }, null, 8, ["value", "options", "loading"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_n_date_picker, {
                  id: "management-installation_date",
                  "formatted-value": _ctx.modelValue.installation_date,
                  "onUpdate:formattedValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelValue.installation_date) = $event)),
                  type: "date",
                  format: "yyyy-MM-dd",
                  size: "large",
                  clearable: "",
                  disabled: _ctx.viewOnly
                }, null, 8, ["formatted-value", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_n_date_picker, {
                  id: "management-contract_expiry",
                  "formatted-value": _ctx.modelValue.contract_expiry,
                  "onUpdate:formattedValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelValue.contract_expiry) = $event)),
                  type: "date",
                  format: "yyyy-MM-dd",
                  size: "large",
                  clearable: "",
                  disabled: _ctx.viewOnly,
                  "is-date-disabled": _ctx.contractExpiryDisabled
                }, null, 8, ["formatted-value", "disabled", "is-date-disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_n_input_number, {
                  id: "client-contract_value",
                  value: _ctx.modelValue.contract_value,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelValue.contract_value) = $event)),
                  size: "large",
                  placeholder: "0.00",
                  disabled: _ctx.viewOnly
                }, {
                  prefix: _withCtx(() => [
                    _createTextVNode(" RM ")
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_n_input_number, {
                  id: "client-service_contract_value",
                  value: _ctx.modelValue.service_contract_value,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelValue.service_contract_value) = $event)),
                  size: "large",
                  placeholder: "0.00",
                  disabled: _ctx.viewOnly
                }, {
                  prefix: _withCtx(() => [
                    _createTextVNode(" RM ")
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}